import React from 'react';
import IconBase from './IconBase';
const EmailIcon = props => React.createElement(IconBase, props, React.createElement("g", null, React.createElement("path", {
  d: "M5.8,8.5L32,34.8L58.4,8.4c0.4-0.4,0.9-0.7,1.4-0.8c-0.3-0.1-0.5-0.1-0.8-0.1H4.4c-0.2,0-0.4,0-0.7,0.1 C4.5,7.6,5.2,7.9,5.8,8.5z"
}), React.createElement("path", {
  d: "M58.7,55.5L39.2,36l-5.1,5.1C33.6,41.7,32.8,42,32,42c0,0,0,0,0,0c-0.8,0-1.6-0.3-2.1-0.9L24.8,36L5.2,55.4 C5,55.7,4.7,55.9,4.4,56c0,0,0,0,0,0H59c0.1,0,0.3,0,0.4,0C59.2,55.8,58.9,55.7,58.7,55.5z"
}), React.createElement("polygon", {
  points: "62,50.3 62,13.2 43.4,31.8 \t"
}), React.createElement("path", {
  d: "M1.5,12.7c-0.1-0.1-0.1-0.1-0.1-0.2v38.3l19.1-19L1.5,12.7z"
})));
EmailIcon.displayName = 'EmailIcon';
export default EmailIcon;
//# sourceMappingURL=EmailIcon.js.map